import moment from 'moment';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { AddIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, Empty, Table } from '@treams/treams-ui';

type Props = {
	tokens: Array<graphql.ApiTokenDescription>;
	email: string;
	onRemove: (id: string) => Promise<void>;
	onAdd: () => Promise<void>;
};

const ApiTokenTable: FC<Props> = ({ tokens, email, onRemove, onAdd }) => {
	const { t } = useTranslation();

	return (
		<Box mt={4}>
			{tokens.length > 0 ? (
				<Table>
					<Table.Header>
						<Table.Cell basis={1}>{t('apitokens.id')}</Table.Cell>
						<Table.Cell basis={1}>{t('apitokens.value')}</Table.Cell>
						<Table.Cell basis={1}>{t('apitokens.type')}</Table.Cell>
						<Table.Cell basis={1}>{t('apitokens.expiresAt')}</Table.Cell>
						<Table.Cell basis={1}>{t('common.actions')}</Table.Cell>
					</Table.Header>

					{tokens.map((token) => {
						return (
							<Table.Row key={token.id}>
								<Table.Cell basis={1}>
									<Box style={{ wordBreak: 'break-all' }}>{token.id}</Box>
								</Table.Cell>
								<Table.Cell basis={1}>{t('apitokens.secret')}</Table.Cell>
								<Table.Cell basis={1}>{token.type}</Table.Cell>
								<Table.Cell basis={1}>{moment(token.expiresAt).format('LLL')}</Table.Cell>

								<Table.Cell basis={1}>
									<Button
										type="destructive"
										disabled={email?.length === 0}
										title={t('apitokens.remove')}
										onClick={async () => {
											await onRemove(token.id);
										}}
									/>
								</Table.Cell>
							</Table.Row>
						);
					})}
				</Table>
			) : (
				<Empty.Card
					title={t('apitokens.emptyTitle')}
					description={t('apitokens.create')}
					footer={
						<Box mt={2}>
							<Button
								icon={<AddIcon />}
								disabled={email.length === 0}
								title={t('apitokens.add')}
								small
								onClick={async () => {
									await onAdd();
								}}
							/>
						</Box>
					}
				/>
			)}
		</Box>
	);
};

export default ApiTokenTable;
